import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { Button, Table } from "reactstrap";
import swal from "sweetalert";
import { encryptStorage } from "../../../constants/EncryptStorage";
import { GetLanguageString } from "../../helper/Components";
import { GetSelectedLanguage } from "../../helper/Method";
import { ApiFund } from "../ApiFund";
import { useTranslation } from "react-i18next";

const IncomingUsraRemittances = () => {
  const { t } = useTranslation();
  const unitId = parseInt(encryptStorage.getItem("loggedInUnitId"));
  const [rows, setRows] = useState([]);

  const load = () => {
    ApiFund()
      .GetIncomingUsraRemittances(unitId)
      .then((res) => setRows(res.data || []))
      .catch(() => setRows([]));
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unitId]);

  const retry = (id) => {
    ApiFund()
      .RetryUsraRemittancePosting(id)
      .then((res) => {
        swal({
          title:
            res.data?.statusCode === "200"
              ? t("usra_retry_posting_done")
              : t(res.data?.message || "usra_retry_posting_failed"),
          icon: res.data?.statusCode === "200" ? "success" : "error",
          className: GetSelectedLanguage() === "en" ? "" : "ur",
        });
        load();
      })
      .catch(() => {
        swal({
          title: t("usra_retry_posting_failed"),
          icon: "error",
          className: GetSelectedLanguage() === "en" ? "" : "ur",
        });
      });
  };

  return (
    <div className="wrapper wrapper-content">
      <div className="ibox">
        <div className="ibox-title">
          <h5>
            <GetLanguageString props="usra_incoming_remittances" />
          </h5>
        </div>
        <div className="ibox-content">
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <GetLanguageString props="usra_name" />
                </th>
                <th>
                  <GetLanguageString props="funds_add_fund_amount" />
                </th>
                <th>
                  <GetLanguageString props="usra_receipt_count" />
                </th>
                <th>
                  <GetLanguageString props="notifications_approve_status" />
                </th>
                <th>
                  <GetLanguageString props="usra_requested_by" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id}>
                  <td>{r.usraName}</td>
                  <td>{r.amount}</td>
                  <td>{r.receiptCount}</td>
                  <td>{r.status}</td>
                  <td>{r.requestedByName}</td>
                  <td>
                    {r.hasPostingRows && (
                      <Button
                        size="sm"
                        color="warning"
                        onClick={() => retry(r.id)}
                      >
                        <GetLanguageString props="usra_retry_posting" />
                      </Button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  );
};

export default withRouter(IncomingUsraRemittances);
